import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import styles from './ExperiencesBilling.scss'
import { QuickStats } from 'features/experiences/QuickStats'
import { experienceActions, experienceSelectors } from 'data/resources/experiences'
import { Card } from 'common/styleguide/Card'
import { Loadable } from 'common/Loadable'
import { CTA } from 'common/styleguide/CTA'
import { Icon } from 'common/Icon'
import fetchJSON from 'lib/fetchJSON'
import _ from 'lodash'

export class _ExperiencesBilling extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      totals: {
        today: null,
        'this week': null,
        'this month': null,
        'this year': null,
        all: null
      }
    }
  }

  componentDidMount () {
    const { loadableResources: { stats } } = this.props
    const { results } = stats
    const toSum = Object.values(results)

    const day = _.sumBy(toSum, (e) => e.today)
    const week = _.sumBy(toSum, (e) => e['this week'])
    const month = _.sumBy(toSum, (e) => e['this month'])
    const year = _.sumBy(toSum, (e) => e['this year'])
    const all = _.sumBy(toSum, (e) => e['all time'])
    this.setState({ totals: { today: day, 'this week': week, 'this month': month, 'this year': year, all } })
  }

  render () {
    const { totals } = this.state
    const { loadableResources: { stats: { results } }, experiencesForClub, match } = this.props
    const clubId = parseInt(match.params.organizationId, 10)
    const experiences = experiencesForClub(clubId).valueSeq().toJS()

    return (
      <div className={styles.ExperiencesBilling}>
        <div className={styles.header}>
          <QuickStats totals={totals} rows={1} className={styles.quickStats} />
          <CTA
            secondary
            margins={false}
            href={`/organizations/${clubId}/experiences_billing.csv`}
            className={styles.aSpecificity}>
            <Icon i='md-download' size={20} />Export CSV
          </CTA>
        </div>
        <Card>
          <table className={styles.table}>
            <thead className={styles.headerRow}>
              <tr>
                <th />
                <th>This month</th>
                <th>This year</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {results && experiences.map(e => <ExperienceRow experience={e} stats={results[`${e.id}`]} key={e.id} />)}
              <tr className={styles.totalsRow}>
                <td>Total</td>
                <td>{totals['this month']}</td>
                <td>{totals['this year']}</td>
                <td>{totals.all}</td>
              </tr>
            </tbody>
          </table>
        </Card>
      </div>
    )
  }
}

const ExperienceRow = ({ experience, stats }) => {
  return (
    <tr className={styles.experienceRow}>
      <td><Link to={`/experiences/${experience.id}/billing`}>{experience.name}</Link></td>
      <td>{stats['this month']}</td>
      <td>{stats['this year']}</td>
      <td>{stats['all time']}</td>
    </tr>
  )
}

const loadInitialData = props => {
  const clubId = parseInt(props.match.params.organizationId, 10)
  const loadExperiences = props.loadAllExperiences(clubId)
  const loadAllStats = fetchJSON(`/clubs/${clubId}/all_experiences_stats.json`)

  return Promise.all([loadAllStats, loadExperiences])
    .then(([stats, experiences]) => ({ stats, _ }))
}

export const ExperiencesBilling = (props) => {
  return <Loadable
    {...props}
    component={_ExperiencesBilling}
    loadingText='Loading Experiences'
    resourceLoaded={() => loadInitialData(props)} />
}

const mapStateToProps = (state) => ({
  experiencesForClub: (clubId) => experienceSelectors.byClubId(state, clubId)
})

const mapDispatchToProps = {
  loadAllExperiences: experienceActions.loadAllExperiences
}

export const ExperiencesBillingContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ExperiencesBilling))
